import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 10 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 20\" id=\"icon-facebook\"><g clip-path=\"url(#icon-facebook_a)\"><path d=\"M6.194 18.404v-8.381h2.823l.42-3.282H6.194v-2.09c0-.947.263-1.595 1.62-1.595h1.72V.13A22.778 22.778 0 0 0 7.014 0C4.52 0 2.806 1.526 2.806 4.327v2.408H0v3.282h2.811v8.387h3.383Z\" fill=\"currentColor\" /></g><defs><clipPath id=\"icon-facebook_a\"><path fill=\"#fff\" d=\"M0 0h9.71v19.42H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol